// extracted by mini-css-extract-plugin
export default {"noData":"useq6pqDyCgudjMeS8N8"};